export default __webpack_public_path__ + "static/media/investment.ba56fde5.svg";